import React from 'react';
import logo from '../kloudynet-logo.jpeg';
import SignInButton from '../auth/SignInButton';

const MARKETPLACE_URL = process.env.REACT_APP_MARKETPLACE_URL
  || 'https://marketplace.microsoft.com/en-us/product/kloudynettechnologiessdnbhd1588004273044.saara-assessment-portal?tab=Overview';

export default function LandingPage() {
  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(180deg,#0D1B2A 0%,#1B2738 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32,
    }}>
      <div style={{
        maxWidth: 720, background: '#fff', borderRadius: 16, padding: '48px 56px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 28 }}>
          <img src={logo} alt="Kloudynet" style={{ width: 48, height: 48, borderRadius: 6, objectFit: 'contain' }} />
          <div>
            <div style={{ fontSize: 24, fontWeight: 700, color: '#0D1B2A', letterSpacing: '-0.02em' }}>SAARA</div>
            <div style={{ fontSize: 12, color: '#7A8899' }}>by Kloudynet</div>
          </div>
        </div>

        <div style={{ fontSize: 28, fontWeight: 700, color: '#0D1B2A', lineHeight: 1.2, marginBottom: 14 }}>
          Secure AI Adoption Readiness Assessment
        </div>
        <div style={{ fontSize: 14, color: '#455A64', lineHeight: 1.6, marginBottom: 32 }}>
          Assess your organisation's AI security posture across 55 controls and 6 domains.
          Auto-score from Microsoft, Google, and AWS. Generate findings reports with
          remediation roadmaps and licensing upgrade paths.
        </div>

        <div style={{ display: 'flex', gap: 12, marginBottom: 36 }}>
          <SignInButton style={{ flex: 1, padding: '12px 20px', fontSize: 14, fontWeight: 600 }}>
            Sign in
          </SignInButton>
          <a
            href={MARKETPLACE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              flex: 1, padding: '12px 20px', fontSize: 14, fontWeight: 600,
              textAlign: 'center', textDecoration: 'none',
              background: '#fff', color: '#0078D4',
              border: '1px solid #0078D4', borderRadius: 6,
            }}>
            Get SAARA on Azure Marketplace
          </a>
        </div>

        <div style={{
          paddingTop: 20, borderTop: '1px solid #EEF0F3',
          fontSize: 11, color: '#7A8899', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8,
        }}>
          <span>NIST AI RMF 1.0 · ISO 42001:2023 · OWASP LLM Top 10 · MITRE ATLAS</span>
          <span>v2.0 · {new Date().getFullYear()}</span>
        </div>
      </div>
    </div>
  );
}
